export default __webpack_public_path__ + "9f521602318e7de21336409d9d207c00.svg";